import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=5b4dfa7d&scoped=true&v-if=listItems.length%20%3E%200&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=5b4dfa7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4dfa7d",
  null
  
)

export default component.exports